import keycloakService from '../../keycloak_service';

import { sinatraOrigin } from '../../config';

const postToApi = (sinatraEndpoint = '', fetchOptions = {}) => fetch(`${sinatraOrigin}/${sinatraEndpoint}`, fetchOptions).then(response => response.json())

export const createAssay = (assayConfiguration = {}) => {
  // We are explicitly saying that MI should calculate all historical assay scores on creation.
  const assayConfig = { ...assayConfiguration };
  assayConfig.window.start = null;
  assayConfig.iopath = assayConfiguration.iopath;

  const body = JSON.stringify(assayConfig)

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: keycloakService.getAuthHeader(),
    },
    body
  };

  return postToApi('v1/api/assays/create', fetchOptions)
}

export default createAssay;
